// Commissions.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "./styles";
import {
  MDBCol,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import api from "../../services/api";
import moment from "moment";

function Commissions() {
  const businessUnitCodeURL = new URLSearchParams(useLocation().search).get(
    "businessUnitCode"
  ); // Pegar o businessUnitCode da URL

  const navigate = useNavigate();

  const [ESLs, setESLs] = useState();

  useEffect(() => {
    api.get(`/logs/actions/commission`).then((response) => {
      setESLs(response.data);
    });
  }, [businessUnitCodeURL]);

  return (
    <Container>
      <h3>Comissionamentos</h3>

      <MDBTable align="start" hover>
        <MDBTableHead>
          <tr>
            <th>Loja</th>
            <th>ESL (MAC)</th>
            <th>Ação</th>
            <th>SLGN</th>
            <th>GTIN</th>
            <th>Data</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {ESLs &&
            ESLs.map((esl) =>
              esl.actions.map((action) => (
                <tr
                  className="table-light"
                  onClick={() => navigate(`/details/${esl.mac}`)}
                >
                  <td>{action.sgln && action.sgln.slice(0, 1)}</td>

                  <td>{esl.mac}</td>
                  {action.action === "commission" && <td>Comissionada</td>}
                  {action.action === "uncommission" && <td>Descomissionada</td>}
                  <td>
                    {action.sgln &&
                      "Seção:" +
                        action.sgln.slice(2, 4) +
                        " - Prat:" +
                        action.sgln.slice(5, 6) +
                        " - Nível:" +
                        action.sgln.slice(7, 8) +
                        " - Slot:" +
                        action.sgln.slice(9, 10) +
                        " - Face:" +
                        action.sgln.slice(11, 12)}
                  </td>
                  <td>{action.productGtin}</td>
                  <td>
                    {moment
                      .utc(action.timestamp)
                      .format("HH:mm:ss - DD/MM/YYYY")}
                  </td>
                </tr>
              ))
            )}
        </MDBTableBody>
      </MDBTable>
    </Container>
  );
}

export default Commissions;
